import Swiper from 'swiper';
import { createMask } from '../components/phone';
import { Modal } from '../components/modal';
import { Metrika } from '../components/metrika';

export function bankrot() {
  const modal = new Modal;
    const metrika = new Metrika;
    let quizInfo = '';
    let phonesInputs = document.querySelectorAll('[data-phoneMask]');
    phonesInputs.forEach( item => {
        createMask(item)
    });

    let inputs = document.querySelectorAll('[am-input]');
    let formError = document.querySelectorAll('[am-error]');
    inputs.forEach( item => {
        item.addEventListener('input', () => {
            item.classList.remove('error');

            formError.forEach( elem => {
                elem.classList.remove('is-active');
            });
        });
    });

    const forms = document.querySelectorAll('.js-FeedbackForm');

    forms.forEach( form => {
      const type = form.dataset.type;

      // Цели - ввод данных в инпуты
      const inputName = form.querySelector('input[name="fio"]');
      const inputPhone = form.querySelector('input[name="phone"]');

      inputName.addEventListener('change', function() {
          if (type == 'modal') {
              metrika.reachGoal('input_name_in_popup_order', this);
          } else if (type == 'modal_offer') {
              metrika.reachGoal('input_name_in_intro_order', this);
          }
      });

      inputPhone.addEventListener('change', function() {
          if (type == 'modal') {
              metrika.reachGoal('input_phone_in_popup_order', this);
          } else if (type == 'modal_offer') {
              metrika.reachGoal('input_phone_in_intro_order', this);
          }
      });

      form.addEventListener('submit', e => {
          e.preventDefault();
          // От повторных кликов
          const btn = form.querySelector('button');
          btn.setAttribute('disabled', '');

          // Данные для отправки
          const formData = new FormData();
          const fio = form.querySelector('input[name="fio"]').value;
          const phone = form.querySelector('input[name="phone"]').value;
          const comment = form.querySelector('textarea');
          const current_page = document.querySelector('input[name="current_page"]').value;

          if (comment) {
              formData.append('comment', comment.value);
          }

          formData.append('fio', fio);
          formData.append('phone', phone);
          formData.append('current_page', current_page);
          formData.append('quizInfo', quizInfo);

          // Отправка
          // fetch('/handler/send_feedback ', {
          //     method: 'POST',
          //     headers: {
          //         'X-Requested-With': 'XMLHttpRequest',
          //     },
          //     body: formData,
          // })
          // .then(response => response.json())
          // .then(r => {
          //     btn.removeAttribute('disabled');
          //     // console.log(r);
          //     if (r.status == 'ok') {

          //         // Цели - отправка формы
          //         if (type == 'modal') {
          //             metrika.reachGoal('submit_popup_order', form);
          //         } else if (type == 'modal_offer') {
          //             metrika.reachGoal('submit_intro_order', form);
          //         } else if (type == 'modal_help') {
          //             metrika.reachGoal('submit_needhelp_order', form);
          //         } else if (type == 'modal_question') {
          //             metrika.reachGoal('submit_questleft_order', form);
          //         }

          //         const activeModal = document.querySelector('[am-block="modal"].is-active');

          //         if (activeModal) {
          //             activeModal.classList.remove('is-active');
          //             document.body.style.overflow = '';
          //             document.documentElement.style.overflow = '';
          //         }

          //         modal.open('modal', 'thx', 'close');
          //         form.querySelector('input[name="fio"]').value = '';
          //         form.querySelector('input[name="phone"]').value = '';
          //     }

          //     if (r.status == 'error') {
          //         const errorText = form.querySelector('.js-formErrorText');
          //         errorText.textContent = r.message;
          //         errorText.classList.add('is-active');

          //         r.fields.forEach(name => {
          //               form.querySelector(`input[name="${name}"]`).classList.add('error');
          //         })
          //     }
          // })
      })
  })





  const swiper = new Swiper('.reviews-swiper', {
    loop: false,
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      bulletClass: 'reviews-slider__bullet',
      bulletActiveClass: 'reviews-slider__bullet_active',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      clickable: true,
    },
    breakpoints: {
      1000: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      768: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: false,
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      100: {
        navigation: false,
        pagination: {
          el: '.swiper-pagination',
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
      }
    }
  });

  const questionNextBtn = document.querySelectorAll('.next-btn')
  const questionPrevBtn = document.querySelectorAll('.prev-btn')
  const accordionBtn1 = document.querySelector('#firstAcc')
  const accordionBtn2 = document.querySelector('#secondAcc')
  const accordionBtn3 = document.querySelector('#thirdAcc')
  const accordionFirst = document.querySelector('#accordion1')
  const accordionSecond = document.querySelector('#accordion2')
  const accordionThird = document.querySelector('#accordion3')
  const examplesBtn = document.querySelector('.examples__btn-more')
  const examplesBlocks = document.querySelectorAll('.examples__content__list__item')
  const readMoreBtnReview = document.querySelectorAll('.review-card__more')
  let reviewTextAreas = document.querySelectorAll('.review-card__text')
  const questionBtn = document.querySelector('.question__btn-more')
  const questionItem = document.querySelectorAll('.question .accordion-item')
  const questionAnswer = document.querySelectorAll('.variant-block')

  questionAnswer.forEach((answer) => {
    answer.addEventListener('click', () => {
      questionAnswer.forEach((el) => {
        el.classList.remove('active-answer')
      })
      answer.classList.add('active-answer')
    })
  })

  if (examplesBtn) {
      examplesBtn.addEventListener('click', () => {
        examplesBlocks.forEach((block) => {
          if (block.classList.contains('hidden')) {
            block.classList.remove('hidden')
          }
        })
        examplesBtn.classList.add('hidden')
      })
  }
  let counter = 0;
  questionNextBtn.forEach((nextBtn) => {
    nextBtn.addEventListener('click', () => {
      counter = 0;
      let questionBlocks = document.querySelectorAll('.question-block')
      questionBlocks.forEach((curBlock) => {
        if (curBlock.getAttribute('data-step') == nextBtn.getAttribute('data-step')) {
          if (curBlock.getAttribute('data-step') == 5) {
          } else {
            let blockVariants = curBlock.querySelector('.variant-block.active-answer');
            if (blockVariants) {
                counter++;
            }
            if (counter > 0) {
                curBlock.classList.add('hidden')
            }
            questionBlocks.forEach((block) => {
              if (block.getAttribute('data-step') == (Number(nextBtn.getAttribute('data-step')) + 1)) {
                if (counter > 0) {
                    block.classList.remove('hidden');
                    if (Number(nextBtn.getAttribute('data-step')) == 1) {
                        quizInfo += 'Сумма долга : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 2) {
                        quizInfo += 'Результат, который хочется получить : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 3) {
                        quizInfo += 'Сумма ежемесячного дохода : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 4) {
                        quizInfo += 'Просрочки по платежам : ';
                    }
                    quizInfo += document.querySelector('.question-block .variant-block.active-answer .text').textContent + '<br /><br />';
                } else {
                    alert('Выберите один из ответов');
                }
              }
            })
          }
        }
      })
    })
  })
  let limiter = 0;
  document.querySelectorAll('.question-block[data-step="5"] .variant-block').forEach((lastblock) => {
    lastblock.addEventListener('click', (e) => {
        document.querySelector('.last-btn').setAttribute('data-open', 'feedback');
        document.querySelector('.last-btn[data-open="feedback"]').addEventListener('click', (e) => {
                if (limiter == 0) {
                    quizInfo += 'Звонки от коллекторов : ';
                    quizInfo += document.querySelector('.question-block[data-step="5"] .variant-block.active-answer .text').textContent + '<br />';
                    limiter++;
                }
        })
    })
  })

if (document.querySelector('.last-btn[data-open="empty"]')) {
    document.querySelector('.last-btn[data-open="empty"]').addEventListener('click', (e) => {
        if (document.querySelector('.last-btn').getAttribute('data-open') == "empty") {
            alert('Выберите один из ответов');
        }
    })
}


  questionPrevBtn.forEach((prevBtn) => {
    prevBtn.addEventListener('click', () => {
      let questionBlocks = document.querySelectorAll('.question-block')
      questionBlocks.forEach((curBlock) => {
        if (curBlock.getAttribute('data-step') == prevBtn.getAttribute('data-step')) {
          curBlock.classList.add('hidden')
          questionBlocks.forEach((block) => {
            if (block.getAttribute('data-step') == (Number(prevBtn.getAttribute('data-step')) - 1)) {
              block.classList.remove('hidden')
            }
          })
        }
      })
    })
  })

if (accordionBtn1) {
    accordionBtn1.addEventListener('click', () => {
      if (accordionFirst.classList.contains('hidden')) {
        accordionFirst.classList.remove('hidden')
        accordionSecond.classList.add('hidden')
        accordionThird.classList.add('hidden')
        accordionBtn1.classList.add('active-block')
        accordionBtn2.classList.remove('active-block')
        accordionBtn3.classList.remove('active-block')
      }
    })
}

if (accordionBtn2) {
    accordionBtn2.addEventListener('click', () => {
      if (accordionSecond.classList.contains('hidden')) {
        accordionSecond.classList.remove('hidden')
        accordionFirst.classList.add('hidden')
        accordionThird.classList.add('hidden')
        accordionBtn2.classList.add('active-block')
        accordionBtn1.classList.remove('active-block')
        accordionBtn3.classList.remove('active-block')
      }
    })
}

if (accordionBtn3) {
    accordionBtn3.addEventListener('click', () => {
      if (accordionThird.classList.contains('hidden')) {
        accordionThird.classList.remove('hidden')
        accordionSecond.classList.add('hidden')
        accordionFirst.classList.add('hidden')
        accordionBtn3.classList.add('active-block')
        accordionBtn2.classList.remove('active-block')
        accordionBtn1.classList.remove('active-block')
      }
    })
}


  reviewTextAreas.forEach((area) => {
    if (window.innerWidth >= 1321) {
      if (area.scrollHeight > 286) {
        let reviewCard = area.closest('.review-card');
        let reviewMoreBtn = reviewCard.querySelector('.review-card__more');

        if (reviewMoreBtn.classList.contains('hidden')) {
          reviewMoreBtn.classList.remove('hidden');
        }
      }
    } else if (window.innerWidth >= 1000) {
      if (area.scrollHeight > 323) {
        let reviewCard = area.closest('.review-card');
        let reviewMoreBtn = reviewCard.querySelector('.review-card__more');

        if (reviewMoreBtn.classList.contains('hidden')) {
          reviewMoreBtn.classList.remove('hidden');
        }
      }
    } else if (window.innerWidth >= 768) {
      if (area.scrollHeight > 266) {
        let reviewCard = area.closest('.review-card');
        let reviewMoreBtn = reviewCard.querySelector('.review-card__more');

        if (reviewMoreBtn.classList.contains('hidden')) {
          reviewMoreBtn.classList.remove('hidden');
        }
      }
    } else {
      if (area.scrollHeight > 285) {
        let reviewCard = area.closest('.review-card');
        let reviewMoreBtn = reviewCard.querySelector('.review-card__more');

        if (reviewMoreBtn.classList.contains('hidden')) {
          reviewMoreBtn.classList.remove('hidden');
        }
      }
    }
  })

  readMoreBtnReview.forEach((btn) => {
    btn.addEventListener('click', () => {
      let reviewCard = btn.closest('.review-card');
      let text = reviewCard.querySelector('.review-card__text');

      if (text.classList.contains('show-all-text')) {
        text.classList.remove('show-all-text');
        btn.textContent = 'Читать полностью';
        text.scrollIntoView({block: "center"});
      } else {
        text.classList.add('show-all-text');
        btn.textContent = 'Скрыть текст';
      }
    })
  })
}

const faqElemB = document.querySelectorAll('.js-faq.bankrot-faq');
const showAllB = document.querySelector('.js-faqShow.bankrot-faqShow');
let activeFaqsB = document.querySelector('.js-faq.bankrot-faq.is-active');
const faqWrapper = document.querySelector('.js-faqWrapper.bankrot-faqWrapper');


faqElemB.forEach( item => {
    item.onclick = function() {
        activeFaqsB = document.querySelectorAll('.js-faq.bankrot-faq.is-active');
        activeFaqsB.forEach( itemToHide => {
            if (itemToHide.classList.contains('is-active')) {
                if (!item.classList.contains('is-active')) {
                    itemToHide.classList.remove('is-active');
                }
            }
        });
        setTimeout(function () {
            this.classList.toggle('is-active');
        }, 100);
    }
});

if (showAllB) {
    showAllB.addEventListener('click', function() {
        if (document.querySelectorAll('.js-faq.js-hiddenFaq.bankrot-faq').length <= 3) {
            showAllB.remove();
        }
        let count = 5;

        document.querySelectorAll('.js-faq.js-hiddenFaq.bankrot-hiddenFaq').forEach(el => {
            if (count > 0) {
                el.style.display = 'block';
                el.classList.remove('js-hiddenFaq');
            }
            count--;
        });
    });
}
